export default __webpack_public_path__ + "media/images/service_transfer-b61f51f465d6a2c3efeb980c2cf0d716.jpg";